import styled, {css} from 'styled-components';

import {Row as BaseRow} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';
import BaseMoreHorizIcon from '@edna/icons/moreHoriz.svg';

import {Badge, TBadgeProps} from 'src/components/Badge/style';

export const ClientStatusText = styled.div`
  ${mixins.f3}
`;

export const Row = styled(BaseRow)`
  ${mixins.flexAlign('flex-start', 'center')}
  ${({theme}) => css`
    gap: ${theme.spacing.s2};
    margin: ${theme.spacing.s2} 0 ${theme.spacing.s4};
  `}
`;

export const Date = styled.div`
  ${mixins.f2}
  font-weight: 600;
  margin-left: ${({theme}) => theme.spacing.s2};
`;

type TClientBadgeProps = TTheme & TBadgeProps;

const getClientBadgeStyle = ({color, theme}: TClientBadgeProps) => {
  switch (color) {
    case 'GREEN':
      return css`
        background-color: ${theme.branding.colors.success};
      `;
    case 'YELLOW':
      return css`
        background-color: ${theme.branding.colors.warning};
      `;
    case 'RED':
      return css`
        background-color: ${theme.palette.red400};
      `;
    default:
      return css`
        background-color: ${theme.branding.colors.info};
      `;
  }
};

export const ClientBadge = styled(Badge)<TClientBadgeProps>`
  width: fit-content;
  ${({theme}) => css`
    color: ${theme.palette.white};
  `}
  ${getClientBadgeStyle};
`;

export const OptionIcon = styled.svg`
  ${({theme: {spacing}}) => css`
    margin-right: ${spacing.s4};
  `}
`;

export const MoreHorizIcon = styled(BaseMoreHorizIcon)`
  transform: rotate(90deg);
`;
